import { localAxios } from './axios';

export function getOptInLists(profileId, platform, config = {}) {
  return localAxios.get(
    `/api/profiles/${profileId}/${platform}/get-lists`,
    config,
  );
}
